import React from 'react';

import { mergeClassNameStrings, supportNumberDisplay } from '@consumer-frontend/nc-utils';
import { Icon } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';

export type NcSupportNumberLinkPropsT = {
  className?: string;
  withIcon?: boolean;
};

export const NcSupportNumberLink: React.FC<NcSupportNumberLinkPropsT> = ({
  className,
  withIcon = false,
}) => {
  const cssClasses = mergeClassNameStrings('non-breaking', className);

  return (
    <a className={cssClasses} href="tel:8773922014">
      {withIcon && <Icon className="me-2" iconName="telephone-fill" />}
      {supportNumberDisplay}
    </a>
  );
};
